<template>
    <div class="mk-exhibtionform col-12 px-0 pb-0">
        <div class="">
            <div class="col-12 dashboard-card admin-input-wrap">
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <h2 style="margin-bottom: 13px;">Details</h2>
                    </v-col>

                    <v-col cols="12" md="6" lg="4">
                        <label>Name</label>
                        <v-text-field
                            outlined
                            v-model="exhibition.name"
                            placeholder=""
                            class="text-field"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <label>Organisation</label>
                        <v-select
                            outlined
                            :items="organisations"
                            item-value="id"
                            item-text="name"
                            v-model="organisation"
                            append-icon="fal fa-chevron-down"
                            @change="selectOrganisation"
                            return-object
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" lg="4">
                        <label>Date</label>
                        <v-menu
                            ref="dateMenu"
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    v-on="on"
                                    v-bind="attrs"
                                    class="date-menu-wrap"
                                    range
                                    prepend-inner-icon="mdi-calendar-month-outline"
                                    placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                ></v-text-field>
                            </template>

                            <v-date-picker
                                v-model="dates"
                                @input="checkDate"
                                range
                                dark
                                color="var(--color-primary)"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="6" lg="4">
                        <label>Gallery</label>
                        <v-select
                            v-model="gallery"
                            outlined
                            :items="galleries"
                            item-value="id"
                            item-text="name"
                            placeholder="Select Organisation first"
                            append-icon="fal fa-chevron-down"
                            @change="selectGallery"
                            return-object
                        ></v-select>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <label>Gallery Address</label>
                        <p>{{ galleryAddress }}</p>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <label>Curator</label>
                        <v-text-field
                            outlined
                            v-model="exhibition.curator"
                            placeholder=""
                            class="text-field"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import Organisation from "../../models/Organisation";
import Exhibition from "../../models/Exhibition";

export default {
    props: {
        init_exhibition: {
            type: Object,
        },
    },

    async mounted() {
        this.getOrganisations();
        this.setExhibition();
    },

    data() {
        return {
            exhibition: new Exhibition(this.init_exhibition),
            type: this.init_exhibition.id ? 'edit' : 'create',
            organisations: [],
            galleries: [],
            organisation: [],
            gallery: [],
            dates: [],
            dateMenu: false,
            galleryAddress: '',
        };
    },

    computed: {
        dateRangeText () {
            let dateRange = '';

            this.dates.forEach((value, index) => {
                if(index == 0) {
                    dateRange += this.formatDate(value);
                    this.exhibition.start_at = value;
                } else {
                    dateRange += '  -  '+this.formatDate(value);
                    this.exhibition.end_at = value;
                }
            });

            return dateRange;
        },
    },

    methods: {
        async getOrganisations() {
            let organisations = await Organisation.include("galleries")
                .orderBy("name")
                .get();
            this.organisations = organisations.data;
        },

        setExhibition() {
            if(this.init_exhibition.id) {
                this.organisation = this.init_exhibition.organisation ?? [];
                this.galleries = this.init_exhibition.organisation.galleries ?? [];
                this.gallery = this.init_exhibition.gallery ?? [];
                this.galleryAddress = this.init_exhibition.gallery.address ?? '';
                this.dates = [this.init_exhibition.start_at, this.init_exhibition.end_at];
            }
        },

        selectOrganisation(event) {
            this.galleries = event.galleries;
        },

        selectGallery(event) {
            this.galleryAddress = event.address;
        },

        async handleSubmit() {
            this.exhibition.organisation_id = this.organisation.id ?? null;
            this.exhibition.gallery_id = this.gallery.id ?? null;

            this.exhibition.save().then((response) => {
                if (response.id && this.type == "create") {
                    window.location.href =
                        "/admin/exhibitions/" + response.id + "/edit";
                }
            });
        },

        checkDate() {
            this.exhibition.start_at = '';
            this.exhibition.end_at = '';

            if(this.dates.length == 2) {
                this.dateMenu = false;
            }
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        }
    },
};
</script>
